import {QbElement} from "@qb-assets-js/qb-elements/qb-element";
import markdownit from '@node/markdown-it';
import TurndownService from '@node/turndown';
const turndownService = new TurndownService();
turndownService.addRule('customBreak', {
    filter: 'br',
    replacement: function () {
        return '\n\n';
    }
});

function splitMdString(mdString) {
    const regex = /(^|\s)@([a-zA-Z]{2})(?=\s|$)/g;
    mdString = mdString.trim();

    const matches = [...mdString.matchAll(regex)].map(m=>[m[2], m.index]);
    if(!matches.length) return mdString.length ? [["xx", mdString]] : [];
    if(matches[0][1]) matches.unshift(["xx", 0]);
    matches.push([]);
    return matches.filter(m=>m[0]).map((m, i)=>[m[0], mdString.slice(...[m[1], matches[i+1][1]]).replace(regex, "").trim()]);
}


function render_md(input) {
    input = input.trim();
    if(/(^|\n)(#{1,6}\s|>\s|(\d+\.|\*|-|\+)\s|\n{2,})/.test(input)) {
        const MD = markdownit();
        MD.block.ruler.disable('heading');
        return MD.render(input);
    }
    else {
        const rv = markdownit({breaks: true}).renderInline(input);
        return rv.replace(/(<br>\n)+/, m=>m.split(/\n/).filter(n=>n).slice(1).join(""));
    }
}

export class QbGettext extends QbElement {
    static shadow = {mode: 'open', sheets: ["qb-elements"]};
    // static shadow = {mode: 'open'};
    static template = "<slot part='slot'></slot><slot name='edit'></slot>";
    static observedAttributes = ["name","edit"]

    constructor() {
        super();
        this.contentRoot.querySelector("[name='edit']").addEventListener("click", evt=>this.handleEvent_toggleEdit(evt));
    }

    handleEvent_toggleEdit(evt) {
        if(!document.documentElement.hasClass("edit")) return;
        // console.log(this.evt && (evt.timeStamp - this.evt.timeStamp));
        // this.evt = evt
        // // if(evt.isDuplicate(this)) return;
        evt.preventDefault();
        // evt.stopPropagation();
        evt.stopImmediatePropagation();
        const edit = this.querySelector("qb-gettext-edit");
        if(edit) {
            this.removeClass("changed");
            return edit.save;
        }
        cT("qb-gettext-edit", {beforeend: this, slot: "edit", attributes: {contenteditable: "true"}}).content = this.md;
    }

    get nodes() {
        return [...this.children].filter(n=>n.lang);
    }

    set multi(_) {}
    get reorder() {
        const langs = document.preferredLang,
            index = l => (langs.indexOf(l) + 1) || 1000,
            nodes = this.nodes.sort((l, h) => {
                const cmp = index(l.lang) - index(h.lang);
                if(cmp) return cmp;
                const lo = l.textContent.trim().toUpperCase(), hi = h.textContent.trim().toUpperCase();
                if (lo < hi) return -1;
                if (lo > hi) return 1;
                if(l.isConnected) h.remove();
                else if(h.isConnected) l.remove();
                return 0;
            }).filter(n=>n.isConnected);
        this.prepend(...nodes);
        // this.textContent = "";
        // if(nodes[0]) this.append(nodes[0].cloneNode(true));
    }

    get init() {
        if(this.children.length) return;
        for(const n of this.childNodes) {
            const data = n.jsonData;
            if(data) return this.content = data;
        }
        // if(this.hasChildNodes) {
        //     this.content = this.textContent;
        // }
    }

    // reprocess() {
    //     ["_", "n_", "p_"].forEach(k => {
    //         if(!this.#content.hasOwnProperty(k)) return;
    //         const v = this.#content[k];
    //         let args;
    //         if(k === "_") args = [i18n?.lang, window[k](v)];
    //         else if(/^[np]_$/.test(k)) args = [i18n?.lang, window[k](...v)];
    //         this.language(...args);
    //     });
    //     this.reorder;
    // }

    get value() {
        const contents = [...this.querySelectorAll("[lang]")].map(n=>
            [n.lang, n.innerHTML.replace(/<qb-mixin key="([^"]+)"><\/qb-mixin>/g, "%{$1}")]
        );
        return this.multi ? contents : Object.fromEntries(contents);
    }


    set value(value) {
        this.nodes.forEach(n => n.remove());
        this.textContent = "";
        if(value === null || value === undefined) return;
        if(typeof value === 'string') value = {"$": value};
        this.update(value);
    }

    set md(value) {
        this.nodes.forEach(n => n.remove());
        this.textContent = "";
        if(value === null || value === undefined) return;
        if(typeof value === 'string') {
            value = splitMdString(value);
            // value = {"$": value};
        }
        if(!(value instanceof Array)) value = Object.entries(value);
        this.update(value.map(([k, v]) => [k, render_md(v)]));
    }

    get md() {
        return [...this.querySelectorAll("[lang]")].map(n=>{
            const html = n.innerHTML.replace(/<qb-mixin key="([^"]+)"><\/qb-mixin>/g, "%{$1}");
            return `@${n.lang} ${turndownService.turndown(html)}`;
        }).join("\n\n");
    }

    set content(value) { this.value = value }
    get content() { return this.value }


    get multi() { return this.hasAttribute("multi") }
    set multi(value) { value ? this.setAttribute("multi", "") : this.removeAttribute("multi") }



    update(value) {
        if(!(value instanceof Array)) value = Object.entries(value);
        value.forEach(([k, v]) => {
            let args;
            if(/boolean|string|number/.test(typeof v)) {
                v = v.toString();
                if(k === "") args = ["$", v]; // FIXME remove after fixing agnostic to key $
                else if(k === "$") args = ["$", v];
                else if(k === "_") args = [i18n?.lang, window[k](v)];
                else if(k.length === 2) args = [k, v];
                else return;
            }
            else if(v instanceof Array) {
                if(/^[np]_$/.test(k)) args = [i18n?.lang, window[k](...v)];
            }
            else return;

            if(args?.length) this.#language(...args);
        });
        this.reorder;
    }

    language(lang, text) {
        this.#language(lang, text);
        this.reorder;
    }

    #language(lang, text) {
        if(lang === undefined) lang = "_";
        if(!/^([a-z]{2}|\$|_)$/.test(lang)) return;
        // const fragment = document.createElement('div');
        // fragment.innerHTML = text || "";
        // fragment.querySelectorAll(":not(hr, img, span[class]):empty").forEach(n => n.remove());
        // text = fragment.innerHTML.trim();
        if(!text) return this.querySelector(`[lang="${lang}"]`)?.remove();
        const node = this.#node(lang || "$", text);
        node.innerHTML = text.replace(/%\{([^}]+)}/g, (m0, m1) => this.#mixin(m1));
        if(!node.isConnected) this.append(node);
        return text;
    }

    #node(lang, text) {
        const id = (lang === "$" ? "XX" : lang) + text.toUpperCase().hashCode,
            selector = this.multi ? `#${id}[lang="${lang}"]` : `[lang="${lang}"]`;
        const node = this.querySelector(selector);
        if(node) return node;
        const events = this.name ? [this, {click: "edit"}] : undefined;
        return SPAN({lang, id, events});
    }

    set #counterIncrement(key) {
        const increments = new Set([...this.style.counterIncrement.matchAll(/([a-z_-]+) \d+/g)].map(m=>m[1])).add(key);
        this.style.counterIncrement = [...increments].join(" ");
    }

    #mixin(key) {
        const m = key.match(/^increment-(([a-z][a-z0-9_-]+)\s*(\S+)?)/);
        if(m) {
            key = `counter-${m[1]}`;
            this.#counterIncrement = m[2];
        }
        return Object.assign(document.createElement("qb-mixin"), {key}).outerHTML;
    }


    get form() { return this.getAttribute("form") }

    get name() { return this.getAttribute('name') }
    set name(value) {
        this.setAttribute('name', value);
    }

}

QbGettext.register;
self.QB_GETTEXT = (...args) => cT('qb-gettext', ...args);
